import { environment } from 'src/environments/environment';

export const ApiConstants = {
  URL: {
    login: `/auth/login`,
    signup: `/external/register`,
    domainList: `/auth/domainList`,
    tenantList: `/external/tenants`,
    updateImage: `/utilities/updateImage`,
    deleteImage: `/auth/deleteImage`,
    configurationsInfo: `/settings/attributeDetails`,
    enquiry: `/external/enquiry`,
    configurations: `/settings/configurations`,
    addConfiguration: `/settings/addConfiguration`,
    updateConfiguration: `/settings/updateConfiguration`,
    deleteConfiguration: `/settings/deleteConfiguration`,
    resetPassword: `/auth/resetPassword`,
    usersList: `/users/users`,
    createUser: `/users/createUser`,
    attribute: `/settings/attributes`,
    deleteUser: `/users/deleteUser`,
    editUser: `/users/updateUserDetails`,
    availableUsername: `/users/checkAvailability`,
    changePassword: `/auth/changePassword`,
    roleType: `/settings/roleTypes`,
    rolesList: `/settings/roles`,
    tradeList: `/settings/trades`,
    availableRoles: `/settings/availableRoles`,
    availableTrades: `/settings/availableTrades`,
    saveRole: `/settings/saveRole`,
    saveTrade: `/settings/saveTrade`,
    logout: `/auth/logout`,
    deleteRole: `/settings/deleteRole`,
    deleteTrade: `/settings/deleteTrade`,
    errorCodes: `/settings/errorCodes`,
    saveErrorCode: `/settings/saveErrorCode`,
    deleteErrorCode: `/settings/deleteErrorCode`,
    saveRoleType: `/settings/saveRoleType`,
    retrieveArchivalDetails: `/settings/retrieveArchivalDetails`,
    getFeatureList: `/settings/features`,
    saveFeature: `/settings/saveFeature`,
    deleteFeature: `/settings/deleteFeature`,
    userGroupList: `/settings/userGroups`,
    userGroupAction: `/settings/saveUserGroup`,
    mongoDBSnapshots: `/settings/mongoDBSnapshots`,
    syncInfoDetails: `/settings/syncInfoDetails`,
    updateTradeImage: `/settings/updateTradeImage`,
    getOtaAppList: `/settings/otaApps `,
    saveOtaApp: `/settings/saveOtaApp`,
    deleteOtaApp: `/settings/deleteOtaApp`,
    uploadOtaFile: `/utilities/uploadFileToBlob`,
    currentAlertRules: `/settings/alertRules`,
    userDetails: `/users/userDetails`,
    roleList: `/settings/roleList`,
    tradesList: `/settings/tradeList`,
    insertAlertRule: `/settings/insertAlertRule`,
    updateAlertRule: `/settings/updateAlertRule`,
    deleteAlertRule: `/settings/deleteAlertRule`,
    alertIdList: `/settings/alertIdList`,
    plantList: `/sites/sites`,
    createPlant: `/sites/createSite`,
    updatePlant: `/sites/updateSiteDetails`,
    deletePlant: `/sites/deleteSite`,
    siteList: `/sites/siteList`,
    siteDetails: `/sites/siteDetails`,
    bulkUpload: `/utilities/bulkUpload`,
    revokePassword: `/users/revokePassword`,
    userGroupPeople: `/users/userGroupList`,
    zoneDetails: `/sites/zones/`,
    getZoneOrder: `/sites/zoneOrder`,
    deleteZone: `/sites/deleteZone`,
    usersMappingInfo: `/sites/usersMappingInfo`,
    allocateZones: `/sites/allocateZones`,
    zoneIconInfo: `/sites/zoneIcons`,
    siteHierarchyInfo: `/sites/siteHierarchyInfo`,
    getZoneHierarchy: `/sites/zoneOrderData`,
    getTemplates: `/settings/templates`,
    createNewZone: `/sites/createZone`,
    updateZoneDetails: `/sites/updateZoneDetails`,
    getPtwList: `/sites/ptwZones`,
    viewPtw: `/sites/ptwZoneDetails`,
    deletePtwZones: `/sites/deletePtwZones`,
    updatePtwZoneDetails: `/sites/updatePtwZoneDetails`,
    availableReaZones: `/sites/availableReaZones`,
    zoneOrderData: `/sites/zoneOrderData`,
    unallocatedPtwUsers: `/sites/unallocatedPtwUsers`,
    ptwUsersAllocation: `/sites/ptwUsersAllocation`,
    availableSites: `/users/availableSites`,
    userSiteAllocation: `/users/userSiteAllocation `,
    userZonesAllocation: `/users/userZonesAllocation`,
    zoneUsersAllocation: `/sites/zoneUsersAllocation`,
    userMappingDetails: `/users/userMappingDetails`,
    getSiteInfo: `/sites/siteInfo`,
    getLogs: `/utilities/logs`,
    entitiesList: `/entities/entities`,
    vehicleProfile: `/entities/entityDetails`,
    blobUpload: `${environment.azureBlobBaseUrl}`,
    createKnowledgeBase: `/knowledgebase/createKnowledgeBase`,
    getKnowledgeBaseList: `/knowledgebase/knowledgeBaseList`,
    getKnowledgeBaseDetails: `/knowledgebase/knowledgeBaseDetails`,
    updateKnowledgeBaseDetails: `/knowledgebase/updateKnowledgeBaseDetails`,
    deleteknowledgeBase: `/knowledgebase/deleteknowledgeBase`,
    alertList: `/alerts/alerts`,
    updateAlert: `/alerts/updateAlerts`,
    updateAlertV1: `/v1/alerts/updateAlerts`,
    alertsCountList: `/alerts/alertsCountList`,
    trackEntity: `/tracker/trackEntity`,
    alertsCount: `/tracker/alertsCount`,
    locateEntity: `/tracker/locateEntity`,
    entityCategories: `/tracker/entityCategories`,
    activeEntities: `/entities/activeEntities`,
    scoreBasedEntities: `/entities/scoreBasedEntities`,
    entityInfo: `/entities/entityInfo`,
    alertStatistics: `/alerts/alertStatistics`,
    getKnowledgeBaseStatistics: `/knowledgebase/knowledgeBaseStatistics`,
    entityAttributes: `/entities/entityAttributes`,
    entityAttributesV1: `/v1/entities/entityAttributes`,
    vehicleStatistics: `/entities/entityStatistics`,
    syncConfigMessage: `/settings/syncConfig`,
    fleetCategoryCount: `/entities/entityCategoryCount`,
    devices: `/devices/devices`,
    deviceSiteAllocation: `/devices/deviceSiteAllocation`,
    deviceSiteDeallocation: `/devices/deviceSiteDeallocation`,
    availableEntities: `/devices/availableEntities`,
    entityDeviceAllocation: `/devices/deviceEntityAllocation`,
    entityDeviceDeallocation: `/devices/deviceEntityDeallocation`,
    deviceTypes: `/devices/deviceTypes`,
    chatRequest: `/external/chatRequest`,
    widgets: `/home/widgets`,
    entityProfile: `/entities/entityDetails`,
    scoreDetails: `/entities/scoreDetails`,
    certificateDetails: `/entities/certificateDetails`,
    driverDetails: `/entities/driverDetails`,
    entityIconList: `/entities/entityAlerts`,
    updateWidgets: '/home/updateWidgets',
    entityHealthStatus: '/entities/entityHealthStatus',
    entityData: '/entities/entityData',
    hasDependencies: `/sites/hasDependencies`,
    monotainerStagingCount: `/widgets/monotainerStagingCount`,
    monotainerCurrentCount: `/widgets/monotainerCurrentCount`,
    monotainerTotalCount: `/widgets/monotainerTotalCount`,
    filterInputData: '/entities/filterInputData',
    availableSupervisors: `/entities/availableSupervisors`,
    entitySiteAllocation: `/entities/entitySiteAllocation`,
    entitySupervisorAllocation: `/entities/entitySupervisorAllocation`,
    entitySiteDeallocation: `/entities/entitySiteDeallocation`,
    notifyUser: '/settings/notifyUser',
    entityCondition: '/entities/entityTemperatureStatus',
    entityInsightsStatistics: '/entities/entityInsightsStatistics',
    entityInsightsAttribute: '/entities/entityInsightsAttribute',
    entityAttributeStatus: '/entities/entityAttributeStatus',
    activeEntityDetails: '/entities/activeEntityDetails',
    availableDevices: `/devices/availableDevices`,
    activeUsers: `/users/activeUsers`,
    updateEntityData: `/entities/updateEntityData`,
    attributeAlertsCount: `/entities/attributeAlertsCount`,
    attributeData: `/entities/attributeData`,
    devicesCount: `/devices/devicesCount`,
    entityCount: `/entities/entityCount`,
    exportEntityData: `/entities/exportEntityData`,
    getPubsubToken: `/alerts/getPubsubToken`,
    fetchLanes: `/v1/sites`,
    entitiesDetails: `/v1/entities`,
    updateRea: `/v1/sites/mapping/bulk`,
    getMapping: `/v1/sites/mappings`,
    deviceRawData: `/devices/deviceRawdata`,
    planogramData: `/v1/tracker/trackEntity`,
    getMonotainerCountDetails: `/v1/widgets/entities`,
    reportRequests: `/v1/reports/requests`,
    serviceNow: `/v1/service-now/incident`,
    imageList: `/v1/utilities/images`,
    saveImage: `/v1/utilities/image/save`,
    devicesList: `/v1/developer/devices/list`,
    deviceLatency: `/v1/developer/devices`,
    fetachLatencyGraph: `/v1/developer/devices/fetchLatencyGraph`,
    fetachLatencyMetrics: `/v1/developer/devices/fetchMetricCounts`,
    fetchRul: `/v1/entities/RUL/fetch`,
    rulCreate: `/v1/entities/RUL/create`,
    replacementCount: `/v1/widgets/vehicle/replacementCount`,
    leastGraph: `/v1/widgets/RUL/statistics/leastGraph`,
    createRul: `/v1/entities/RUL/create`,
    rulStatistics: `/v1/entities/RUL/statistics`,
    userOrAppNameDetails: `/v1/users/userOrAppNameDetails`,
    exportDeviceList: `/v1/developer/devices/export`,
    rulStatsExport: `/v1/entities/RUL/statistics/export`,
    trackerExport: `/tracker/trackEntity/export`,
    activeEntityExport: `/entities/activeEntityDetails/export`,
    rulStatisticsV: `/v2/entities/RUL/statistics`,
    scheduledReports: `/v1/reports/schedule/requests`,
    deleteSchedule: `/v1/reports/schedule/deleteSchedule`,
    quickShareReport: `/v1/reports/quickShare`,
    externalAuthentication: `/v1/auth/authentication`,
    attributeAggregation: `/v1/entities/attributeAggregation`,
    entityAttributeValue: `/v1/entities/entityAttributeValue`,
    reportSummary: `/v1/reports/schedule/requests/summary`,
    entityUsageStatistics: `/v1/entities/entityUsageStatistics`,
    entityCategoryState: `/v1/entities/entityCategoryState`,
    attributeAggregateValue: `/v1/entities/attributeAggregateValue`,
    getElasticUsage: `/v1/developer/devices/elasticUsage`,
    fetachLatencyCountGraph: `/v2/developer/devices/fetchLatencyGraph`,
    padWear: `/v2/entities/RUL/analysis/padWear`,
    brakeEvent: '/v2/entities/RUL/analysis/brakeEvent',
    brakeEventGroup: `/v2/entities/RUL/analysis/brakeEventGroup`,
    availableEntitiesFloorPlan: `/v1/entities/floorplan/entities`,
    geoHistory: `/v1/entities/history`,
    features: `/v1/users/features`,
    alertsExport: `/alerts/alerts/export`,
    deviceExport: `/devices/devices/export`,
    zonesExport: `/sites/zones/export`,
    scheduleExport: `/v1/reports/schedule/requests/export`,
    reportsExport: `/v1/reports/requests/export`,
    monotainerExport: `/history/export`,
    cnpZonesExport: `/zones/export`,
    entityModuleHealth: '/v1/devices/statistics/module/metrics',
    widgetStatus: '/v2/entities/reportingStatus',
    mappingAttribute: `/v1/sites/mappings/attribute`,
    getPeripheralMetrics: `/v1/devices/statistics/peripheral/metrics`,
    getPeripheralHistory: `/v1/devices/statistics/peripheral/history`,
    chatRequestV1: `/v1/external/chatRequest`,
    getEntitySummary: '/v1/entities/summary',
    floorPlanEntities: `/v1/entities/floorplan/entities`,
    createEntityLocation: `/v1/entities/floorplan/updateEntityLocation`,
    updateEntityLocation: `/v1/entities/floorplan/updateEntityLocation`,
    deleteEntityLocation: `/v1/entities/floorplan/deleteEntityLocation`,
    getEntity: `/v3/entities`,
    createEntity: `/v3/entities`,
    updateEntity: `/v3/entities`,
    entityAggrSummary: `/v2/entities/aggr/summary`,
    entityAggrLatest: `/v2/entities/aggr/entitySummary`,
    entityAggregation: `/v1/entities/floorplan/entityAggregation`,
    trackerEntityCount: `/v3/entities/floorplan/trackerEntityCount`,
    getLatestDTC: `/v4/widgets/latestDtc`,
    getVehicleType: `/v2/widgets/vehicleType`,
    getVehicleState: `/v2/widgets/vehicleState`,
    getTrackerVehicleState: `/v1/tracker/vehicleState`,
    getDtcList: `/v2/dtc`,
    getDtcCount: `/v2/dtc/DTCCount`,
    getDtcSeverity: `/v2/dtc/DTCSeverity`,
    getDtcState: `/v2/dtc/DTCState`,
    getCaseStates: `/v2/cases/state`,
    getCaseList: `/v2/cases`,
    updateCaseData: `/v2/cases`,
    getprojectsList: `/cases/protus/projects`,
    getModelsList: `/cases/protus/models`,
    addProtus: `/v2/cases/protus/addProtus`,
    addComments: `/comments`,
    commentList: `/comments/list`,
    addDtc: `/dtc`,
    fetchStates: `/v1/states/`,
    fetchActiveDtcCaseCount: `/v2/cases/activeCount`,
    analyticsChartV1: `/v1/chartLibrary`,
    selfServieChartV1: `/v1/chart`,
    activeDates: `/v1/entities/activeDates`,
    ruleScenarioV1: `/v1/rulescenarios`,
    planogramSummary: `/v1/tracker/floorplan/summary`,
    planogramTis: `/v1/tracker/floorplan/TIS`,
    planogramTimeplase: `/v1/tracker/floorplan/state/summary`,
    planogramHistory: `/v1/tracker/floorplan/TIS/history`,
    dtcDownload: `/dtc/export`,
    dtcBulkUpload: `/dtc/bulkUpload`,
    insights: `/v2/entities/insights/latest`,
    tripSegments: `/v2/entities/insights`,
    tripPerformanceScore : `/v2/entities/trips/score`,
    currentTripPosition : `/v2/entities/trips/rank`,
    attributesAggregate : `/v2/entities/attributes/aggr`,
    entityBulkUpload : `/v4/entities/bulkUpload`,
    entityDownload : `/v3/entities/export`,
    protusCheck: `/cases/protus/status`,
    dtcExport: `/v2/dtc/export`,
    caseExport: `/v2/cases/export`,
    dtcAge: `/v2/dtc/age`,
    fetchPreSignedUrl: `/v1/files/s3/uploadFile`,
    getPresignedUrls: `/v1/files/s3/getPresignedUrls`,
    getProtusV2: `/v2/cases/protus`,
    protusAggregate: `/cases/protus/aggregate`,
    protusAggregateExport: `/cases/protus/getAggregate/export`,
    downloadProtusFile: `/cases/protus/download`,
    protusExport: `/v2/cases/protus/export`,
    getUserGroups: `/v1/settings/userGroups`,
    createAlertProfile: `/v1/alerts/alertRule`,
    updateProtusV2: `/v2/cases/protus/updateProtus`,
    protusReoccurence: `/v2/cases/protus/reoccurence`,
    getBlueprint: `/blueprint/blueprint`,
    getFuelAggregate: `/v4/widgets/fuel/aggr/summary`,
    nozzleTransactions: `/outlets/nozzleTransactions`,
    activeEntityDetailsV1: `/v1/entities/activeEntityDetails`,
    updateBlueprint: `/blueprint/solace`,
    auditHistory: `/blueprint/ota/requests`,
    edgeRulesPublish: `/v1/rulescenarios/edge/rules/publish`,
    transactionDetails: `/v1/fuelTransaction`,
    updateAlertV2: `/v2/alerts/alertPublishing`,
    exportTransactions: `/outlets/nozzleTransactions/export`,
    activeEntitiesExportV1: `/v1/entities/activeEntityDetails/export`,
    irasPriceUpdate: `/blueprint/iras/priceUpdate`,
    enableTestMode: `/outlets/testModeUpdate`,
    nozzlePriceSummary: `/outlets/priceSummary`
  },
  HERE_TILE_URL: environment?.hereTileUrl,
  HERE_API_KEY: environment?.hereApiKey,
  HERE_REVERSE_GEOCODE_URL: environment?.hereReverseGeocodeUrl,
  appToken: environment.appToken,
  appId: environment.appId,
  //Password Authentication
  secretKey: environment.secretKey,
  global_settings: {
    pageIndex: 0,
    pageSize: 10,
    pageSizeOptions: [10, 20, 30, 100],
  },
  webSocketUrl: 'to be deleted on new implimentation',
  blobSasToken: environment.sas,
  API_ENDPOINT: environment.apiEndPoint,
};
